'use strict';

angular.module('amexReconciliationApp')
  .service('CompanyRepository', function ($resource) {
    var self = this;

    self.findAllCompanies = function () {
      return $resource('/api/v1/companies').query().$promise
        .then(function (response) {
          return response;
        });
    };

    self.getUsersForCompany = function (companyId) {
      return $resource('/api/v1/companies/:companyId/users').query({ companyId: companyId }).$promise;
    };

    self.findByCompanyId = function(companyId) {
      return $resource('/api/v1/companies/:companyId').get({ companyId: companyId }).$promise
        .then(function (company) {
          return company;
        });
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/CompanyRepository.js
// module id = 607
// module chunks = 0